export const hero = {
positioning: 'One More Global Inc.',
title: 'Wellness. Personal Care. Direct Sales.',
subtitle: 'Quality consumer products supported by disciplined operations, responsible market development, and long-term business relationships.',
cta_structure: 'Explore Products',
cta_contact: 'Contact Corporate Office',
location: 'Houston, Texas, USA',
stat_1_value: 'Americas',
stat_1_label: 'Americas Coverage',
stat_2_value: 'Houston, TX',
stat_2_label: 'Headquarters',
stat_3_value: 'Direct Sales',
stat_3_label: 'Business Model',
};
